import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const EInvoicingAutoForwardToggleWrapper = styled.div`
  padding: ${Spacing.S16};
`
